export const treeData = [
  {
    title: '总览',
    key: '1',
    relativePath: 'a',
    children: [
      {
        title: '节点1-1',
        key: '1-1',
        relativePath: 'b',
        scopedSlots: { title: 'custom' },
        children: [
          {
            title: '节点1-1-1',
            key: '1-1-1',
            relativePath: 'c',
            scopedSlots: { title: 'custom' },
          },
          {
            title: '节点1-1-2',
            key: '1-1-2',
            relativePath: 'd',
            scopedSlots: { title: 'custom' },
          },
          {
            title: '节点1-1-3',
            key: '1-1-3',
            relativePath: 'e',
            scopedSlots: { title: 'custom' },
          },
        ],
      },
    ],
  },
];

export const treeData2 = [
  {
    title: '总览',
    key: '1',
    relativePath: 'a',
    children: [
      {
        title: '节点1-1',
        key: '1-1',
        relativePath: 'b',
        scopedSlots: { title: 'custom' },
        children: [
          {
            title: '节点1-1-1',
            key: '1-1-1',
            relativePath: 'c',
            scopedSlots: { title: 'custom' },
          },
          {
            title: '节点1-1-2',
            key: '1-1-2',
            relativePath: 'd',
            scopedSlots: { title: 'custom' },
          },
        ],
      },
    ],
  },
];
